import { axios } from '@/plugins';

const fetchData = async ({ commit }, url) => {
  try {
    const { data } = await axios.get(url);
    const { links, permissions } = data.report;
    commit('SET_LINKS', links);
    commit('SET_PERMISSIONS', permissions);
  } catch (err) {
    throw err;
  }
};

const downloadConsumptionReport = async (_, url) => {
  await axios.get(`${url}&resource=consumption`);
};

const fetchConsumptionReportUsages = async ({ commit }, { url, params }) => {
  const {
    data: { usages, links },
  } = await axios.get(url, { params });
  commit('SET_REPORT_CONSUMPTION_USAGES', usages);
  commit('SET_CONSUMPTION_REPORT_USAGES_DOWNLOAD_URL', links.consumptionUsageDetailDownload);
};

const fetchConsumptionReportUsagesDetails = async ({ commit }, { url, perPage, page }) => {
  const link = `${url}&per_page=${perPage || 10}&page=${page || 1}`;

  const {
    data: { items, pagination },
  } = await axios.get(link);
  commit('SET_REPORT_CONSUMPTION_USAGES_DETAILS', items);
  if (pagination.perPage < 10) pagination.perPage = 10;
  commit('SET_REPORT_CONSUMPTION_USAGES_DETAILS_PAGINATION', pagination);
};

const downloadConsumptionReportUsages = async (_, url) => {
  await axios.get(url);
};

const fetchConsumptionUsagesTotal = async ({ commit }, url) => {
  const {
    data: { usages },
  } = await axios.get(url);
  commit('SET_REPORT_CONSUMPTION_USAGES', usages);
};

export default {
  fetchData,
  downloadConsumptionReport,
  fetchConsumptionReportUsages,
  fetchConsumptionReportUsagesDetails,
  downloadConsumptionReportUsages,
  fetchConsumptionUsagesTotal,
};
